export default __webpack_public_path__ + "static/flutter-562d1d9f8c617a8e019e3cdb0c7dd2a7.png";